/*
* Retrieve the cache ID for an object cached by the apollo client.
*
* This cache ID is useful for comparisons and for iterating over objects that do not have an `id`
* graphql field.
*
* This function works by resolving the symbol `id` for the pass object and retrieving this property
* from the object. This can not be done by simply accessing the name of the symbol and requires a
* reference to this symbol.
*
* NOTE: I doubt this function will work with objects not cached by apollo client.
* Furthermore, I doubt it will give meaningful errors when it fails.
 */
const getCachedObjectId = (cachedObject) => {
  const symbolId = Object.getOwnPropertySymbols(cachedObject)[0];
  const id = cachedObject[symbolId];

  return id;
};


export default getCachedObjectId;
